import { API_BASE_URL } from "../assets/const";
import { checkAndUpdateToken } from "./auth";
import { buildDefaultHeaders } from "./helper";
import { createNotification } from "../components/Notifications/Notifications";
import {
  GET_THEME_PLANNING,
  SET_THEME_PLANNING_LOAD,
  SET_THEME_PLANNING_TEACHERS,
  SET_THEME_PLANNING_COURSES,
  SET_THEME_PLANNING_WEEKS,
  SET_THEME_PLANNING_LESSON,
  SET_THEME_PLANNING_EVENT_TYPES,
  SET_THEME_PLANNING_WEIGHTS,
  SET_THEME_PLANNING_THEMES,
  SET_THEME_PLANNING_TRIALS,
  SET_THEME_PLANNING_MODAL_LOAD,
  CLEAR_THEME_PLANNING_LESSON,
  CLEAR_THEME_PLANNING
} from "./types";

// Грид уроков за неделю
export const getThemePlanning = (teacher_mid, cid, week_id, type = 0) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: SET_THEME_PLANNING_LOAD, payload: true });

    const params = new URLSearchParams({
      teacher_mid,
      week_id,
      type
    });
    if (cid && cid !== '0' && cid !== 0) {
      params.append('cid', cid);
    }

    const response = await fetch(`${API_BASE_URL}/thematic_planning?${params}`, {
      method: "GET",
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) {
      const data = await response.json();
      dispatch({ type: GET_THEME_PLANNING, payload: data.data || [] });
    } else {
      dispatch({ type: GET_THEME_PLANNING, payload: [] });
    }
  }
  dispatch({ type: SET_THEME_PLANNING_LOAD, payload: false });
};

// Список учителей за неделю
export const getThemePlanningTeachers = (week_id, type = 0) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const params = new URLSearchParams({ week_id });
    if (type) {
      params.append('type', type);
    }

    const response = await fetch(`${API_BASE_URL}/library/teacher/week?${params}`, {
      method: "GET",
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) {
      const data = await response.json();
      dispatch({ type: SET_THEME_PLANNING_TEACHERS, payload: data.data || data.teachers || data || [] });
    }
  }
};

// Список предметов учителя за неделю
export const getThemePlanningCourses = (teacher_mid, week_id, type = 0) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const params = new URLSearchParams({
      teacher_mid,
      week_id
    });
    if (type) {
      params.append('type', type);
    }

    const response = await fetch(`${API_BASE_URL}/library/courses/teacher/week?${params}`, {
      method: "GET",
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) {
      const data = await response.json();
      dispatch({ type: SET_THEME_PLANNING_COURSES, payload: data.data || data.courses || data || [] });
    }
  }
};

// Список недель
export const getThemePlanningWeeks = (school_year, trmid) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const params = new URLSearchParams();
    if (school_year) {
      params.append('school_year', school_year);
    }
    if (trmid && trmid !== 0) {
      params.append('trmid', trmid);
    }

    const response = await fetch(`${API_BASE_URL}/library/weeks?${params}`, {
      method: "GET",
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) {
      const data = await response.json();
      dispatch({ type: SET_THEME_PLANNING_WEEKS, payload: data.data || data.weeks || data || [] });
    }
  }
};

// Данные урока для формы редактирования
export const getThemePlanningLesson = (sheid, week_id, type = 0) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: SET_THEME_PLANNING_MODAL_LOAD, payload: true });

    const params = new URLSearchParams({
      sheid,
      week_id
    });
    if (type) {
      params.append('type', type);
    }

    const response = await fetch(`${API_BASE_URL}/thematic_planning/lesson?${params}`, {
      method: "GET",
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) {
      const data = await response.json();
      dispatch({ type: SET_THEME_PLANNING_LESSON, payload: data });
    }
    dispatch({ type: SET_THEME_PLANNING_MODAL_LOAD, payload: false });
  }
};

// Сохранить тему урока
export const saveThemePlanningLesson = (body, type = 0) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: SET_THEME_PLANNING_MODAL_LOAD, payload: true });

    const params = new URLSearchParams();
    if (type) {
      params.append('type', type);
    }

    const response = await fetch(`${API_BASE_URL}/thematic_planning/lesson?${params}`, {
      method: "POST",
      ...buildDefaultHeaders(getState),
      body: JSON.stringify(body),
    });

    dispatch({ type: SET_THEME_PLANNING_MODAL_LOAD, payload: false });

    if (response.ok) {
      createNotification('success', 'Данные успешно сохранены');
      return true;
    } else {
      const errorData = await response.json().catch(() => ({}));
      createNotification('error', errorData.detail || errorData.message || 'Ошибка сохранения');
      return false;
    }
  }
  return false;
};

// Типы занятий
export const getThemePlanningEventTypes = (type = 0) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    // const params = new URLSearchParams();
    // if (type) {
    //   params.append('type', type);
    // }
// ?${params}
    const response = await fetch(`${API_BASE_URL}/thematic_planning/event_types`, {
      method: "GET",
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) {
      const data = await response.json();
      dispatch({ type: SET_THEME_PLANNING_EVENT_TYPES, payload: data.data || data.event_types || data || [] });
    }
  }
};

// Веса оценок
export const getThemePlanningWeights = () => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(`${API_BASE_URL}/thematic_planning/weights`, {
      method: "GET",
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) {
      const data = await response.json();
      dispatch({ type: SET_THEME_PLANNING_WEIGHTS, payload: data.data || data.weights || data || [] });
    }
  }
};

// Дерево тем
export const getThemePlanningThemes = (cid, teacher_mid, year_id, gid, sheid, type = 0) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const params = new URLSearchParams({
      cid,
      teacher_mid,
      year_id
    });
    if (gid) {
      params.append('gid', gid);
    }
    if (sheid) {
      params.append('sheid', sheid);
    }
    if (type) {
      params.append('type', type);
    }

    const response = await fetch(`${API_BASE_URL}/thematic_planning/themes?${params}`, {
      method: "GET",
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) {
      const data = await response.json();
      dispatch({ type: SET_THEME_PLANNING_THEMES, payload: data.data || data.themes || data || [] });
    }
  }
};

// Периоды
export const getThemePlanningTrials = (sheid, week_id) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const params = new URLSearchParams({
      sheid,
      week_id
    });

    const response = await fetch(`${API_BASE_URL}/thematic_planning/trials?${params}`, {
      method: "GET",
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) {
      const data = await response.json();
      dispatch({ type: SET_THEME_PLANNING_TRIALS, payload: data.data || data.trials || data || [] });
    }
  }
};

// Очистить данные урока
export const clearThemePlanningLesson = () => (dispatch) => {
  dispatch({ type: CLEAR_THEME_PLANNING_LESSON });
};

// Очистить список уроков
export const clearThemePlanning = () => (dispatch) => {
  dispatch({ type: CLEAR_THEME_PLANNING });
};
